export function removeUndefinedParams<T extends object>(params: T): Partial<T> {
  const cleanedParams: Partial<T> = { ...params }
  for (const key of Object.keys(cleanedParams)) {
    if (cleanedParams[key as keyof T] == null) {
      delete cleanedParams[key as keyof T]
    }
  }
  return cleanedParams
}
